
<template>
  <div class="globe-details">
    <h1 class="globe-details__title">{{item.title()}}</h1>
    <h2 class="globe-details__subtitle">{{item.subTitle()}}</h2>
    <p class="globe-details__item">
      <span>Coordinates</span>
      <span>{{item.lat().toFixed(3)}}, {{item.lon().toFixed(3)}}</span>
    </p>
    <p v-if="item.timezone()" class="globe-details__item">
      <span>Time</span>
      <current-time v-bind:timezone="item.timezone()"></current-time>
    </p>
    <p v-if="item.flightTime()" class="globe-details__item">
      <span>Flight Time</span>
      <span>{{item.flightTime()}}</span>
    </p>
  </div>
</template>
<script>
  import CurrentTime from './CurrentTime';

  export default {
    name: 'globeDetails',
    props: ['item'],
    components: { CurrentTime },
  };
</script>
<style lang="scss" scoped>
  @import '../main.scss';
  .globe-details {
    position: absolute;
    bottom: 50%;
    left: 50%;
    margin-left: -500px;
    margin-bottom: -250px;
    background: rgba(#092531, 0.75);
    padding: 10px;
    width: 350px;
    z-index: 15;
    color: white;
    border-radius: 10px;

    > * {
      margin: 0;
      padding: 0;
    }
  }



  .globe-details__title {
    color: white;;
    font-size: 4rem;
    font-weight: 200;
    letter-spacing: 4px;
    line-height: 4rem;
  }
  .globe-details__subtitle {
    color: $appPrimary;
    font-size: 2rem;
    letter-spacing: 4px;
    font-weight: 700;
  }

  @include globe-detail-line();

  @media only screen and (max-width: 600px) {
    .globe-details {
      bottom: 0;
      left: 0;
      right: 0;
      margin-bottom: 0;
      margin-left: 0;
      width: unset;
      background: #f6f6f6;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/GlobeDetails.vue